import colors from "./base/colors";
import spacing from "./base/spacing";
import typography from "./base/typography";
import breakpoints from "./base/breakpoints";
import animations from "./base/animations";

const theme= {
  colors,
  spacing,
  typography,
  breakpoints,
  animations,
};

export default theme;
